import IssueDetails from 'components/IssueDetails/components/IssueDetails';
import IssuesCategorisation from 'components/IssueCategorisation/components/IssueCategorisation';
import { NewObservationPhotos } from 'components/ObservationPhoto/components/NewObservationPhoto/NewObservationPhotos';
import React from 'react';
import { useTranslation } from 'react-i18next';
import IssueReporter from 'sections/issues-management/pages/ViewAmmendIssue/components/IssueReporter';
import {
    StyledPanelGrid,
    StyledPanelRow,
    StyledPanelColumn,
    StyledContainer
} from 'shared/styled/panel.stayled';
import { ObservationFileEntity } from 'shared/types/file/ObservationFileEntity';
import { IAddFiles } from 'shared/utils/files/types/IAddFiles';

interface NewIssueFormProps {
    handleAddFile: IAddFiles<ObservationFileEntity>;
    handleDeleteFile: (ids: string[]) => void;
}

const NewIssueForm = ({
    handleAddFile,
    handleDeleteFile
}: NewIssueFormProps) => {
    return (
        <React.Fragment>
            <StyledContainer>
                <StyledPanelGrid fluid>
                    <StyledPanelRow>
                        <StyledPanelColumn md={12} lg={4} xl={4}>
                            <IssuesCategorisation readOnly={false} />
                        </StyledPanelColumn>
                        <StyledPanelColumn md={12} lg={4} xl={4}>
                            <IssueDetails readOnly={false} />
                            <NewObservationPhotos handleAddFile={handleAddFile} handleDeleteFile={handleDeleteFile} useEnglish />
                        </StyledPanelColumn>
                        <StyledPanelColumn md={12} lg={4} xl={4}>
                            <IssueReporter 
                                isReadOnly={false} 
                                reporterReadOnly={false}
                                useEnglish
                            />
                        </StyledPanelColumn>
                    </StyledPanelRow>
                </StyledPanelGrid>
            </StyledContainer>
        </React.Fragment>
    );
};

export default NewIssueForm;